import React from 'react';
import { Zap } from 'lucide-react';
import { formatAura } from '../lib/aura';

/** Massive Aura score display (the hero number). */
export default function AuraScore({ points = 0, size = 'lg', testId = 'aura-score' }) {
  const sizes = {
    sm: 'text-2xl',
    md: 'text-4xl',
    lg: 'text-5xl sm:text-6xl',
    xl: 'text-6xl sm:text-7xl',
  };
  return (
    <div data-testid={testId} className="inline-flex items-center gap-2">
      <Zap className="text-aura-cyan drop-shadow-[0_0_12px_rgba(0,240,255,0.9)] animate-aura-pulse" size={size === 'sm' ? 18 : 32} />
      <span className={`aura-text-gradient font-display font-black tracking-tight ${sizes[size]}`}>
        {formatAura(points)}
      </span>
      <span className="font-display font-semibold text-white/70 text-xs sm:text-sm tracking-[0.2em]">AURA</span>
    </div>
  );
}
